import { render } from "./swiper.vue?vue&type=template&id=6af217b8&scoped=true"
import script from "./swiper.vue?vue&type=script&lang=js"
export * from "./swiper.vue?vue&type=script&lang=js"

import "./swiper.vue?vue&type=style&index=0&id=6af217b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af217b8"],['__file',"src/js/components/swiper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6af217b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6af217b8', __exports__)) {
    api.reload('6af217b8', __exports__)
  }
  
  module.hot.accept("./swiper.vue?vue&type=template&id=6af217b8&scoped=true", () => {
    api.rerender('6af217b8', render)
  })

}


export default __exports__